// src/pages/UpcomingGamesPage.jsx

import React, { useState, useEffect } from 'react'; // <--- Added useEffect
import './UpcomingGamesPage.css';

// --- IMPORTS ---
// Video
import sutraVideoSource from '../assets/videos/sutra-promo.mp4'; 

// Images
import rajuImg from '../assets/images/jugaad-raju.png';
import jackImg from '../assets/images/hustle-jack.png';
import noBoredomLogo from '../assets/images/no-boredom.png';

const UpcomingGamesPage = () => {
  // --- SCROLL TO TOP FIX ---
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []); // Empty dependency array ensures this runs once when page loads
  // --- STATE MANAGEMENT (For Buttons) ---
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isEmailModalOpen, setIsEmailModalOpen] = useState(false);
  const [email, setEmail] = useState('');
  const [emailStatus, setEmailStatus] = useState('idle');

  const handleOverlayClick = (e) => {
    if (e.target.className === 'modal-overlay') {
      setIsFormOpen(false);
      setIsEmailModalOpen(false);
    }
  };

  const handleEmailSubmit = (e) => {
    e.preventDefault();
    setEmailStatus('submitting');
    setTimeout(() => {
      setEmailStatus('success');
    }, 1500);
  };

  return (
    <section className="upcoming-page-container">
      
      {/* --- HEADER SECTION --- */}
      <div className="upcoming-header">
        <h1 className="upcoming-title">Our Games</h1>
        <h2 className="upcoming-tagline">One Download. Infinite Worlds.</h2>
      </div>

      {/* --- TRIAD LAYOUT: Game | Logo | Game --- */}
      <div className="game-triad-container">
        
        {/* LEFT: HUSTLE JACK */}
        <div className="game-card">
          <div className="game-img-wrapper">
            <img src={jackImg} alt="Hustle Jack" className="character-img" />
          </div>
          <div className="game-info">
            <h2 className="game-name">Hustle Jack</h2>
            <span className="game-badge irish-badge">Ireland</span>
            <p>
              Navigate Dublin's rainy alleys. Use wit and rowdy pub patrons to distract authorities.
            </p>
          </div>
        </div>

        {/* CENTER: NO BOREDOM LOGO */}
        <div className="center-logo-wrapper">
          <img src={noBoredomLogo} alt="No Boredom Allowed" className="no-boredom-img" />
        </div>

        {/* RIGHT: JUGAAD RAJU */}
        <div className="game-card">
          <div className="game-img-wrapper">
            <img src={rajuImg} alt="Jugaad Raju" className="character-img" />
          </div>
          <div className="game-info">
            <h2 className="game-name">Jugaad Raju</h2>
            <span className="game-badge indian-badge">India</span>
            <p>
              Master the art of "Jugaad". Combine unlikely objects to create elaborate escape plans.
            </p>
          </div>
        </div>

      </div>

      {/* --- VIDEO & ACTION SECTION --- */}
      <div className="video-section">
        <div className="video-wrapper">
          <video 
            className="sutra-video" 
            controls 
            autoPlay 
            muted 
            loop 
            playsInline
          >
            <source src={sutraVideoSource} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>

        <div className="action-buttons-container">
          <button 
            onClick={() => setIsEmailModalOpen(true)}
            className="action-btn wishlist-btn"
          >
            <span>♥</span> Wishlist Now
          </button>

          <button 
            onClick={() => setIsFormOpen(true)} 
            className="action-btn form-btn"
          >
            <span>📝</span> Join Beta
          </button>
        </div>
      </div>

      {/* --- MODALS (Hidden by default) --- */}
      
      {/* MS Form Modal */}
      {isFormOpen && (
        <div className="modal-overlay" onClick={handleOverlayClick}>
          <div className="modal-content form-modal-size">
            <button className="close-modal-btn" onClick={() => setIsFormOpen(false)}>&times;</button>
            {/* REPLACE WITH YOUR MS FORM LINK */}
            <iframe 
              src="https://forms.cloud.microsoft/Pages/ResponsePage.aspx?id=e5V92hEVQkqy9Xj4R_jIeknwnD8WXV5KrA11kYZu68tUNlRUVVUyRlpXUTFWODM3NjNUU0o5T01UNS4u" 
              title="Beta Signup"
              className="ms-form-frame" 
              allowFullScreen
            ></iframe>
          </div>
        </div>
      )}

      {/* Email Modal */}
      {isEmailModalOpen && (
        <div className="modal-overlay" onClick={handleOverlayClick}>
          <div className="modal-content email-modal-size">
            <button className="close-modal-btn" onClick={() => setIsEmailModalOpen(false)}>&times;</button>
            
            <div className="email-capture-container">
              {emailStatus === 'success' ? (
                <div className="email-success-msg">
                  <h2>Success!</h2>
                  <p>You're on the list.</p>
                </div>
              ) : (
                <>
                  <h2>Stay Updated</h2>
                  <p>Enter email to unlock Wishlist.</p>
                  <form onSubmit={handleEmailSubmit} className="email-form">
                    <input 
                      type="email" 
                      placeholder="Email address" 
                      required 
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className="email-input"
                    />
                    <button type="submit" className="action-btn form-btn full-width">
                      {emailStatus === 'submitting' ? '...' : 'Notify Me'}
                    </button>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      )}

    </section>
  );
};

export default UpcomingGamesPage;